// extracted by mini-css-extract-plugin
export default {"container":"j_fnQe","horizontalSnap":"yNnRlb","next":"q9QnBN","previous":"V89huM","blank":"NWj09_"};